import { PRODUCT_GROUP, STOCK_TYPE } from './constants'

export const productGroupIdtoText = (id) => {
  switch (id) {
    case PRODUCT_GROUP.TIRES:
      return 'ยาง'
    case PRODUCT_GROUP.PARTS:
      return 'อะไหล่'
    case PRODUCT_GROUP.OTHERS:
      return 'อื่นๆ'
    default:
      return 'ไม่ระบุ'
  }
}

export const stockTypeIdtoText = (id) => {
  switch (id) {
    case STOCK_TYPE.STOCK:
      return 'สินค้านับสต๊อก'
    case STOCK_TYPE.NONSTOCK:
      return 'สินค้าไม่นับสต๊อก'
    case STOCK_TYPE.SERVICE:
      return 'บริการ'
    default:
      return 'ไม่ระบุ'
  }
}

export default productGroupIdtoText
